import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            titles: []
        };
    },

    getters: {
        titles: (state) => state.titles,
    },

    mutations: {
        gotTitles(state, response) {
            state.titles = response.data;
        },
    },

    actions: {
        async fetchTitles({ commit, state }) {
            if (state.titles.length === 0) {
                commit('gotTitles', await API.get('/app/dictionary/?type=title'));
            }
        },
    },

};
